import React from 'react'
import ContactForm from '../components/ContactForm'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

export default function Contact() {
  return (
    <div className="home-page">
    <Navbar />
    <ContactForm />
  
    <Footer />
  </div>
  )
}
